/**
 * PDP Multiple Trust - Swiper + Expand/Collapse
 */

(function () {
  var SWIPER_MEDIA = {};
  var SWIPER_UGC = {};

  function initPdpMultipleTrust(section) {
    var sectionId = section.getAttribute('data-section-id');
    if (!sectionId) return;

    // ---------- UGC Swiper (Mobile Only) ----------
    var ugcEl = section.querySelector('.pdp-multiple-trust__ugc-cards--' + sectionId);
    if (ugcEl && !ugcEl.classList.contains('swiper-initialized')) {
      var isMobile = window.matchMedia('(max-width: 749px)').matches;

      var ugcSwiper = new Swiper(ugcEl, {
        slidesPerView: isMobile ? '1.2' : 3,
        spaceBetween: isMobile ? 12 : 24,
        // Enable trackpad (wheel-event) horizontal swipe
        mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        thresholdDelta: 30,
        thresholdTime: 500,
        },
        watchOverflow: true,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        on: {
          init: function () {
            this.el.classList.add('swiper-initialized');
          }
        }
      });

      SWIPER_UGC[sectionId] = ugcSwiper;

      // Re-init on resize for breakpoint switching
      var ugcResizeHandler = function () {
        var mobile = window.matchMedia('(max-width: 749px)').matches;
        if (ugcEl.swiper) {
          ugcEl.swiper.params.slidesPerView = mobile ? 1.2 : 3;
          ugcEl.swiper.params.spaceBetween = mobile ? 12 : 24;
          ugcEl.swiper.update();
        }
      };

      window.addEventListener('resize', ugcResizeHandler);
      ugcEl._resizeHandler = ugcResizeHandler;
    }

    // ---------- Media Swiper ----------
    var mediaEl = section.querySelector('.pdp-multiple-trust__media-cards--' + sectionId);
    var progressFill = section.querySelector('.pdp-multiple-trust__media-progress-fill');
    var prevBtn = section.querySelector('.pdp-multiple-trust__media-arrow--prev');
    var nextBtn = section.querySelector('.pdp-multiple-trust__media-arrow--next');

    if (mediaEl && !mediaEl.classList.contains('swiper-initialized')) {
      var isMobileMedia = window.matchMedia('(max-width: 749px)').matches;

      var mediaSwiper = new Swiper(mediaEl, {
        slidesPerView: isMobileMedia ? 1.2 : 3,
        spaceBetween: isMobileMedia ? 12 : 20,
        // Enable trackpad (wheel-event) horizontal swipe
        mousewheel: {
          forceToAxis: true,
          sensitivity: 1.5,
          thresholdDelta: 20,
          thresholdTime: 600,
        },
        watchOverflow: true,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn
        },
        on: {
          init: function () {
            this.el.classList.add('swiper-initialized');
            updateProgress(this);
            unifyMediaSlideHeights(this);
          },
          slideChange: function () {
            updateProgress(this);
          }
        }
      });

      SWIPER_MEDIA[sectionId] = mediaSwiper;

      if (progressFill) {
        mediaSwiper._progressFill = progressFill;
      }

      // Resize handler for media
      var mediaResizeHandler = function () {
        var mobile = window.matchMedia('(max-width: 749px)').matches;
        if (mediaEl.swiper) {
          mediaEl.swiper.params.slidesPerView = mobile ? 1.2 : 3;
          mediaEl.swiper.params.spaceBetween = mobile ? 12 : 20;
          mediaEl.swiper.update();
          updateProgress(mediaEl.swiper);
          unifyMediaSlideHeights(mediaEl.swiper);
        }
      };

      window.addEventListener('resize', mediaResizeHandler);
      mediaEl._resizeHandler = mediaResizeHandler;
    }

    // ---------- Media Expand/Collapse ----------
    var mediaCards = section.querySelectorAll('.pdp-multiple-trust__media-card');
    mediaCards.forEach(function (card) {
      var btn = card.querySelector('[data-action="toggle-text"]');
      var inner = card.querySelector('.pdp-multiple-trust__media-card-inner');

      if (!btn || !inner) return;

      // Remove old handler by cloning
      var newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);

      newBtn.addEventListener('click', function () {
        section.querySelectorAll('.pdp-multiple-trust__media-card-inner').forEach(function (el) {
          el.classList.add('is-expanded');
        });
        // Force Swiper to re-measure slide heights after expand/collapse
        if (mediaEl && mediaEl.swiper) {
          mediaEl.swiper.update();
          unifyMediaSlideHeights(mediaEl.swiper);
        }
      });
    });
  }

  function updateProgress(swiper) {
    if (!swiper || swiper.isBeginning === undefined) return;
    var fill = swiper._progressFill;
    if (!fill) {
      fill = swiper.el.closest('.pdp-multiple-trust__media-cards-wrapper')
        ?.querySelector('.pdp-multiple-trust__media-progress-fill');
      if (fill) swiper._progressFill = fill;
    }
    if (!fill) return;

    var totalSlides = swiper.slides.length;
    var slidesPerView = swiper.params.slidesPerView;
    var maxIndex = totalSlides - slidesPerView;
    if (maxIndex <= 0) {
      fill.style.width = '100%';
      return;
    }

    var progress = swiper.activeIndex / maxIndex;
    var percent = 25 + progress * 75; // min 25%, max 100%
    fill.style.width = Math.min(100, Math.max(25, percent)) + '%';
  }

  function unifyMediaSlideHeights(swiper) {
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (!isMobile) return;

    var slides = swiper.slides;
    if (!slides || !slides.length) return;

    // Reset all to auto first so we measure natural height
    slides.forEach(function (s) { s.style.height = ''; });

    var maxHeight = 0;
    slides.forEach(function (s) {
      if (s.offsetHeight > maxHeight) maxHeight = s.offsetHeight;
    });

    // Apply tallest height to all slides
    slides.forEach(function (s) { s.style.height = maxHeight + 'px'; });
    swiper.update();
  }

  function destroySection(section) {
    var sectionId = section.getAttribute('data-section-id');
    if (!sectionId) return;

    if (SWIPER_UGC[sectionId]) {
      SWIPER_UGC[sectionId].destroy(true, true);
      delete SWIPER_UGC[sectionId];
      var ugcEl = section.querySelector('.pdp-multiple-trust__ugc-cards--' + sectionId);
      if (ugcEl && ugcEl._resizeHandler) {
        window.removeEventListener('resize', ugcEl._resizeHandler);
      }
    }

    if (SWIPER_MEDIA[sectionId]) {
      SWIPER_MEDIA[sectionId].destroy(true, true);
      delete SWIPER_MEDIA[sectionId];
      var mediaEl = section.querySelector('.pdp-multiple-trust__media-cards--' + sectionId);
      if (mediaEl && mediaEl._resizeHandler) {
        window.removeEventListener('resize', mediaEl._resizeHandler);
      }
    }
  }

  // Init all on DOM load
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.pdp-multiple-trust').forEach(initPdpMultipleTrust);
  });

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (section.classList.contains('pdp-multiple-trust')) {
      initPdpMultipleTrust(section);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target;
    if (section.classList.contains('pdp-multiple-trust')) {
      destroySection(section);
    }
  });
})();
